import React, { useReducer, createContext } from "react";
import { Auth } from "aws-amplify";
import axios from "axios";

const initialState = {
  user: null,
};

const AuthContext = createContext({
  user: null,
  login: (userData) => {},
  logout: () => {},
});

function authReducer(state, action) {
  switch (action.type) {
    case "LOGIN": {
      axios.defaults.headers.common["Authorization"] = action.payload;
      return {
        ...state,
        user: action.payload,
      };
    }
    case "LOGOUT": {
      axios.defaults.headers.common["Authorization"] = "";
      return {
        ...state,
        user: null,
      };
    }
    default:
      return state;
  }
}

function AuthProvider(props) {
  const [state, dispatch] = useReducer(authReducer, initialState);

  const login = (userData) => {
    // localStorage.setItem("user", JSON.stringify(userData));
    dispatch({
      type: "LOGIN",
      payload: userData,
    });
  };

  const logout = () => {
    dispatch({
      type: "LOGOUT",
    });
  };

  return (
    <AuthContext.Provider
      value={{ user: state.user, login, logout }}
      {...props}
    />
  );
}

export { AuthContext, AuthProvider };
